import { render, staticRenderFns } from "./GroupBottomBar.vue?vue&type=template&id=3b2651a7&"
import script from "./GroupBottomBar.vue?vue&type=script&lang=js&"
export * from "./GroupBottomBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports